module.exports = __webpack_public_path__ + "img/image_part_006.af41f404.jpg";